import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface EmptyStateProps {
  icon: IconDefinition;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actions,
}) => {
  return (
    <div style={{ textAlign: "center", padding: "40px 20px" }}>
      <div
        style={{
          width: 76,
          height: 76,
          borderRadius: 38,
          background: "#f3f4f6",
          margin: "0 auto 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{ fontSize: 28, color: "#9aa0a6" }}
        />
      </div>

      <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
        {title}
      </div>

      {description && (
        <div
          style={{
            color: "#9aa0a6",
            maxWidth: 560,
            margin: "0 auto 16px",
            display: "none", // Can be changed to "block" when needed
          }}
        >
          {description}
        </div>
      )}

      {actions && (
        <div
          style={{
            display: "none", // Can be changed to "flex" when needed
            gap: 12,
            justifyContent: "center",
          }}
        >
          {actions}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
